import { Typography, Button, Box, Container } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';

export default function PageNotFound() {
  return (
    <Container maxWidth='lg' sx={{ textAlign: 'center', py: 6 }}>
      <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column' height='100vh'>
        <Typography variant='h1' fontSize={56} fontWeight='bold' color='primary' gutterBottom>
          404
        </Typography>
        <Typography variant='h5' color='textSecondary' gutterBottom>
          Oops! The page you're looking for doesn't exist.
        </Typography>
        <Typography variant='body1' color='textSecondary' sx={{ mb: 4 }}>
          It might have been removed, or you may have mistyped the address. Please check again.
        </Typography>
        <Grid container spacing={2} justifyContent='center'>
          <Grid>
            <Link to='/' style={{ textDecoration: 'none' }}>
              <Button variant='contained' color='primary' size='large'>
                Go to Homepage
              </Button>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
